const updateFeature = async (context, payload) => {
  context.commit('updateFeature', payload)
}

export default {
  updateFeature
}
